// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_GROWL_YOUR_USERNAME_WILL_BE_SHOWN = "V tejto diskusii sa tvoje prihlasovacie meno bude zobrazova\u0165.";
export const FORUM_GROWL_YOUR_USERNAME_WONT_BE_SHOWN = "V tejto diskusii sa tvoje prihlasovacie meno nebude zobrazova\u0165.";
export const FORUM_POST_DRAFT_FOR_TICKET_INTRO = "Pros\u00edm o zalo\u017eenie diskusie bez mojej \u00fa\u010dasti. Text diskusie m\u00e1 by\u0165:";
